import type { App } from 'vue'
import AppPageFilterBranch from './app-page-filter-branch.vue'
import AppPageFilterDate from './app-page-filter-date.vue'
import AppPageFilterProductGroup from './app-page-filter-product-group.vue'
import AppPageFilterSearch from './app-page-filter-search.vue'
import AppPageFilterSupplier from './app-page-filter-supplier.vue'

export default {
  install (app: App) {
    app.component('AppPageFilterSearch', AppPageFilterSearch)
    app.component('AppPageFilterDate', AppPageFilterDate)
    app.component('AppPageFilterBranch', AppPageFilterBranch)
    app.component('AppPageFilterSupplier', AppPageFilterSupplier)
    app.component('AppPageFilterProductGroup', AppPageFilterProductGroup)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppPageFilterSearch: typeof AppPageFilterSearch,
    AppPageFilterDate: typeof AppPageFilterDate,
    AppPageFilterBranch: typeof AppPageFilterBranch,
    AppPageFilterSupplier: typeof AppPageFilterSupplier,
    AppPageFilterProductGroup: typeof AppPageFilterProductGroup,
  }
}
